export default __webpack_public_path__ + "static/media/img9.be727061.png";